import React, { useState, useEffect } from 'react'
import axios from 'axios'
import './Gallery.css'
import Header from './Header'
import { Col, Row } from 'react-bootstrap'
import { EventAluminiGalleryFindAll, ImagePath } from '../../ApiFile'
import Sidebar from './sidebar'
import MobileNavbarAlumini from './MobileNavbarAlumini'

const GalleryAlumini = () => {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false)
  const [images, setImages] = useState([])

  useEffect(() => {
    fetchImages()
  }, [])

  const fetchImages = async () => {
    try {
      const response = await axios.get(EventAluminiGalleryFindAll)
      setImages(response.data)
    } catch (error) {
      console.error('Error fetching images:', error)
    }
  }

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle)
  }

  return (
    <>
      <div className="roomchange-container" style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar on the left for desktop */}
      <div className="d-none d-md-block sidebar-container" style={{ width: '270px', flexShrink: 0, }}>
        <Sidebar />
      </div>

      {/* Main content on the right */}
      <div className="main-content flex-grow-1" style={{ flex: 1, backgroundColor: '#f8f9fa'}}>
        <Header />
                     
                           <div className="d-block d-md-none">
                             <MobileNavbarAlumini />
                           </div>

        {/* <div className="scrollable-content" style={{ overflow: 'scroll' }}> */}

          <div className="border w-100 h-100 py-3 px-2" style={{backgroundColor:"#f5f5f5ff"}}>
          <div className="row m-0 block-header ps-3">
            <h5 className="room-change-title text-start mt-md-4 mt-2" style={{ color: '#0783d6' }}>
              Gallery
            </h5>
          </div>

          <div className="tab-class text-center p-2 p-md-4 shadow rounded" style={{ backgroundColor:"white" }}>
            <div className="tab-content">
              <div id="GalleryTab-1" className="tab-pane fade show p-0 active">
                <div className="row g-2">
                  {images.map((image) => (
                    <div
                      key={image.id}
                      className="col-sm-6 col-md-6 col-lg-4 col-xl-3"
                    >
                      <div className="gallery-item h-100">
                        <img
                          src={`${ImagePath}/${image.upload_img}`}
                          className="img-fluid w-100 h-100 rounded"
                          alt={`${ImagePath}/${image.upload_img}`}
                        />
                        {/* <div className="gallery-plus-icon">
                        <a href={`${API_URL}/uploads/${image.upload_img}`} data-lightbox={`gallery-${image.id}`} className="my-auto">
                          <i className="fas fa-plus fa-2x text-white" />
                        </a>
                      </div> */}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
      </div>
    </>
  )
}

export default GalleryAlumini
